export const ADDRESS_TYPES = [
  { id: 1, label: 'IP', value: 'ip' },
  { id: 2, label: 'Domain', value: 'domain' },
  { id: 3, label: 'Email', value: 'email' }
];

export default ADDRESS_TYPES;
